import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { NSANDI_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import RecordsSection, { RecordsSubSectionProps } from './records-section'
import getValueTotal from './value-total'

const Nsandi = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => (
  <RecordsSection
    heading="2.5 NS&I"
    cardType="NS&I account"
    addLabel="Add NS&I account"
    toggleName="nationalSavingsAndInvestmentsSectionActive"
    sectionActive={sectionActive}
    saveProbateEstateField={saveProbateEstateField}
    collection={collection}
    totals={{ total: getValueTotal(collection.items) }}
    schema={NSANDI_SCHEMA}
    renderFields={({ handleSave, pairedFieldSpan }) => (
      <>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="referenceNumber"
            label="NS&I holder’s number"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="value"
            label="Value (£)"
            isCurrency
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default Nsandi
